import { render } from "./FreezeInfo.vue?vue&type=template&id=32b102d0"
import script from "./FreezeInfo.vue?vue&type=script&lang=js"
export * from "./FreezeInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__